"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollapsibleColumn = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("../styled-components"));
const react_i18next_1 = require("react-i18next");
const __1 = require("..");
const CollapsibleColumn = ({ heading, initiallyExpanded, width, children, }) => {
    const [expanded, setExpanded] = react_1.default.useState(!!initiallyExpanded);
    // Pass the i18next namespace so that this library works in another package's context
    const { t } = (0, react_i18next_1.useTranslation)("central-web-app-components");
    return (react_1.default.createElement(Column, { expanded: expanded, maxWidth: width, style: { padding: 0 } },
        expanded ? (react_1.default.createElement("div", { className: "hover-highlight" },
            react_1.default.createElement(__1.Flex, { noWrap: true, noResize: true, noOverflow: true, width: "100%", style: {
                    padding: "10px",
                    cursor: "pointer",
                }, onClick: () => setExpanded(!expanded) },
                react_1.default.createElement(__1.SmallHeading, null, heading || ""),
                react_1.default.createElement(Filler, null),
                react_1.default.createElement(CollapseButton, { expanded: expanded },
                    react_1.default.createElement(__1.ChevronDown, { title: t `button-Collapse` }))))) : null,
        expanded ? (react_1.default.createElement(__1.Flex, { col: true, noWrap: true, width: "100%", height: "100%", padding: "0px 10px 10px 10px" }, children)) : (react_1.default.createElement(__1.Flex, { style: {
                cursor: "pointer",
            }, onClick: () => setExpanded(!expanded) },
            react_1.default.createElement("div", { className: "hover-highlight", style: {
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    width: "52px",
                    paddingTop: "10px",
                } },
                react_1.default.createElement(CollapseButton, { expanded: expanded },
                    react_1.default.createElement(__1.ChevronDown, { title: t `button-Expand` })),
                react_1.default.createElement(RotatedHeading, null, heading || ""),
                react_1.default.createElement(ButtonBlank, null))))));
};
exports.CollapsibleColumn = CollapsibleColumn;
const Column = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex-basis: ${({ expanded, maxWidth }) => expanded ? (maxWidth ? maxWidth + "px" : "auto") : "52px"};
  flex-wrap: nowrap;
  max-width: ${({ maxWidth }) => (maxWidth ? maxWidth + "px" : "auto")};
  min-width: 52px;
  height: 100%;
  overflow: hidden;
  @media screen and (prefers-reduced-motion: no-preference) {
    transition:
      flex-basis 0.25s,
      max-width 0.25s;
  }
  border-radius: ${({ theme }) => theme.radius};
  padding: ${({ theme }) => theme.spacing};
  background: ${({ theme }) => theme.panelInner};
`;
const CollapseButton = (0, styled_components_1.default)(__1.FlatButton) `
  &:hover {
    background: transparent;
    box-shadow: none;
  }
  padding: 0;
  width: 30px;
  min-width: auto;
  margin: 1px;
  svg {
    transform: rotate(${({ expanded }) => (expanded ? "90" : "270")}deg);
  }
`;
const RotatedHeading = (0, styled_components_1.default)(__1.SmallHeading) `
  // writing-mode: sideways-lr is not yet supported in Chromium, so we use vertical-lr and rotate
  // (because UX say the text has to read bottom-to-top, not top-to-bottom as standard)
  writing-mode: vertical-lr;
  transform: rotate(180deg);
  flex: 1;
  margin: ${({ theme }) => theme.spacing} 0;
  text-align: center;
`;
const Filler = styled_components_1.default.div `
  flex: 1 1 0;
`;
// Fills a space the size of the button at the bottom of the column to keep text centred
const ButtonBlank = styled_components_1.default.div `
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  margin: 1px;
`;
//# sourceMappingURL=index.js.map